/* Página del local. El texto y las preguntas salen de los ajustes de cada sección;
   aquí solo va lo que depende del reloj y del catálogo. */
(function () {
  var P = GP.productos, esc = GP.esc, foto = GP.foto, url = GP.url, clp = GP.fmt;
  var $ = GP.$;
  var est = GP.estadoLocal();

  GP.pintarDatos();

  var estado = $('#estado');
  if (estado) {
    estado.className = 'estado' + (est.abierto ? ' on' : '');
    estado.innerHTML = '<i></i><div><b>' + esc(est.texto) + '</b><span>' + esc(est.retiro) + '</span></div>';
  }

  var mosaico = $('#mosaico');
  if (mosaico) {
    mosaico.innerHTML = P.filter(function (p) { return p.img && p.p > 50000; })
      .sort(function (a, b) { return b.p - a.p; }).slice(0, 3)
      .map(function (p) {
        return '<a href="' + url(p) + '"><div><img src="' + foto(p) + '" alt="' + esc(p.n) + '" loading="lazy">' +
          '<span>' + clp(p.p) + '</span></div></a>';
      }).join('');
  }

  /* ---------- los días, con el de hoy marcado ---------- */
  var hoy = $('#hoy');
  if (hoy) {
    var DIAS = [['Lunes', '10:30 a 19:30'], ['Martes', '10:30 a 19:30'], ['Miércoles', '10:30 a 19:30'],
                ['Jueves', '10:30 a 19:30'], ['Viernes', '10:30 a 19:30'], ['Sábado', '11:00 a 15:00']];
    var idxHoy = (function () {
      var d;
      try { d = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' })).getDay(); }
      catch (e) { d = new Date().getDay(); }
      return d === 0 ? -1 : d - 1;
    })();
    hoy.innerHTML = DIAS.map(function (d, k) {
      return '<div class="dia' + (k === idxHoy ? ' esHoy' : '') + '"><b>' + d[0] + '</b><span>' + d[1] + '</span>' +
        (k === idxHoy ? '<small>Hoy</small>' : '') + '</div>';
    }).join('') + '<div class="dia"><b>Domingo</b><span>Cerrado</span></div>';
  }

  /* ---------- una muestra de lo que hay para oler ---------- */
  var vitrina = $('#vitrina');
  if (vitrina) {
    var cuantos = +vitrina.getAttribute('data-gp-cuantos') || 10;
    vitrina.innerHTML = GP.grid(
      P.filter(function (p) { return p.img && p.fo === 'perfume'; })
       .sort(function (a, b) { return b.p - a.p; }).slice(0, cuantos));
  }

  /* ---------- acordeón de preguntas ---------- */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-acor]'); if (!b) return;
    var cu = document.getElementById('acor-' + b.getAttribute('data-acor'));
    if (!cu) return;
    var abierto = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', String(!abierto));
    cu.hidden = abierto;
  });
})();
